import {
  AvgTimeToDeliverByCarrierResponseSchema,
  OMSMetricsRequestSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getAvgTimeToDeliverByCarrier = {
  name: "getAvgTimeToDeliverByCarrier" as const,
  input: OMSMetricsRequestSchema,
  output: AvgTimeToDeliverByCarrierResponseSchema,
};
